import React, { Component } from "react";
import { connect } from "react-redux";
import "./index.css";
import SignInContainer from "../../components/containers/SignInContainer";
import { Row, Col, Card, Input, Button } from "antd";
import { AuthAction } from "../../store/actions";
import CustomModal from "../../components/modals/customModal";
import Profile_success from "../../assets/images/profile_success.png";
import UserIcon from "../../assets/images/User.png";
import UserIconOver from "../../assets/images/UserOver.png";
import ContractorLogo from "../../assets/images/contractor-logo.png";
class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      emailError: "",
      passwordError: "",
      isOpen: false,
    };
  }

  onHandleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      [`${e.target.name}Error`]: "",
      errorReducer: "",
    });
  };
  onSubmit = () => {
    const { email } = this.state;

    if (!email.length) {
      if (!email.length) {
        this.setState({
          emailError: "Username is required.",
        });
      }
      return;
    }
    this.props.ResetPassword({ email }, () =>
      this.setState({
        isOpen: true,
      })
    );
  };
  componentDidUpdate(preProps, PreState) {
    if (preProps.error !== this.props.error && !this.props.loader) {
      this.setState({
        errorReducer: "Oops, thats not a match",
      });
    }
  }

  render() {
    const { signin, loader, error } = this.props;
    const { emailError, isOpen, errorReducer } = this.state;
    return (
      <SignInContainer>
        <Row justify="center" className="contractor-sreen-position-center">
          <Col xs={22} sm={18} md={12} lg={11} xl={24}>
            <Row justify="center">
              <Col span={24} style={{ marginTop: "5rem" }}>
                <Card style={{ width: "18pvw", minWidth: '380px' }}>
                  <Row gutter={[0, 15]} style={{ position: "relative" }}>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      style={{
                        height: "140px",
                        width: '155px',
                        borderRadius: "50%",
                        backgroundSize: "contain",
                        backgroundImage: `url(${ContractorLogo})`,
                        position: "absolute",
                        top: "-90px",
                        left: "27%",
                        display: 'block',
                        backgroundRepeat:'no-repeat'
                      }}
                    >
                    </Col>
                    <Col span={24} style={{ marginTop: "80px" }}>
                      <Row justify="center">
                        <Col span={20}>
                          <Input
                            style={{
                              borderBottom: "1px solid #e7e8ed",
                              padding: "10px",
                              fontSize: '1.1rem',
                              letterSpacing: '.5px',
                            }}
                            bordered={false}
                            size="25"
                            placeholder="USERNAME"
                            name="email"
                            onMouseOver={(e) => {
                              this.setState({
                                [`${e.target.name}_onHover`]: true,
                              });
                            }}
                            onMouseOut={(e) => {
                              this.setState({
                                [`${e.target.name}_onHover`]: false,
                              });
                            }}
                            onChange={this.onHandleChange}
                            prefix={
                              <img
                                src={
                                  !this.state["email_onHover"] ?
                                    UserIcon
                                    :
                                    UserIconOver
                                } />
                            }
                          />
                          <Row>
                            <Col span={24}>
                              <span className="text-right d-grid danger-color">
                                {emailError && emailError}
                              </span>
                            </Col>
                          </Row>
                          <Row>
                            <Col span={24}>
                              <span className="text-center d-grid danger-color">
                                {errorReducer && errorReducer}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={24}>
                      <Col style={{ marginTop: "20px" }}>
                        <Button
                          style={{
                            backgroundColor: "#ff9800",
                            color: "#fff",
                            width: "50%",
                            letterSpacing: '.5px',
                            transition: '.2s ease-out(red)',
                            fontSize: '12px',
                          }}
                          onClick={this.onSubmit}
                        >
                          RESET
                        </Button>
                      </Col>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>

        <CustomModal
          visible={isOpen}
          onCancelModal={() =>
            this.setState({
              isOpen: false,
            })
          }
          footer={[
            <Row justify="center" style={{ margin: "20px" }}>
              <Col
                className="d-flex justify-content-center"
                style={{ width: "100%" }}
              >
                <Button
                  style={{
                    backgroundColor: "#ff9800",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() => this.setState({ isOpen: false })}
                >
                  Ok
                </Button>
              </Col>
            </Row>,
          ]}
        >
          <Row justify="center">
            <Col className="d-flex justify-content-center" span={24}>
              <img src={Profile_success} />
            </Col>
            <Col span={18} style={{ textAlign: "center" }}>
              <span>
                An email with instructions has been sent to your inbox
              </span>
            </Col>
          </Row>
        </CustomModal>
      </SignInContainer>
    );
  }
}

function mapStateToProps(storeState) {
  return {
    loader: storeState?.AuthReducer.loader,
    error: storeState?.AuthReducer.error,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ResetPassword: (payload, cb) => {
      dispatch(AuthAction.ResetPassword(payload, cb));
    },
    socialSignIn: (payload, cb) => {
      dispatch(AuthAction.SocialSignInReq(payload, cb));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
